import React from "react";
import ExtraCostsState from "../interface/ExtraCostsState";
import AppSettingController from "../../../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../../../Main/interface/MarketSettingLocalStorage";
import Toast from "../../../../../utility/toast";
import i18n from "../../../../../i18n";

export default class ExtraCostsController {
    protected state: ExtraCostsState;
    protected setState: React.Dispatch<React.SetStateAction<ExtraCostsState>>;

    constructor(state: ExtraCostsState, setState: React.Dispatch<React.SetStateAction<ExtraCostsState>>) {
        this.state = state;
        this.setState = setState;
    }

    async addExtraCosts(e: any) {
        e.preventDefault();
        if (!this.state.extraCostsName) return this.updateState({
            ...this.state,
            error: true,
            message: i18n.t("setting.error.extraCostsNameRequired")
        });

        if (this.state.type === "price" && !this.state.extraCostsPrice) return this.updateState({
            ...this.state,
            error: true,
            message: i18n.t("setting.error.extraCostsPriceRequired")
        });

        if (this.state.type === "percentage" && !this.state.extraCostsPercentage) return this.updateState({
            ...this.state,
            error: true,
            message: i18n.t("setting.error.extraCostsPercentageRequired")
        });

        this.setState({
            error: false,
            extraCostsName: "",
            extraCostsPercentage: "",
            extraCostsPrice: "",
            extraCostsPriceSeparator: "",
            state: 'active',
            type: "percentage",
            message: "",
        })

        if (this.state.isActiveEdit && this.state.id) {
            AppSettingController.editExtraCosts(
                this.state.id,
                this.state.extraCostsName,
                `${this.state.extraCostsPercentage}`,
                `${this.state.extraCostsPrice}`,
                this.state.type,
                this.state.state,
            )
            Toast.success(i18n.t("toast.addExtraCostsSuccess"))
        } else {
            AppSettingController.extraCosts(
                this.state.extraCostsName,
                `${this.state.extraCostsPercentage}`,
                `${this.state.extraCostsPrice}`,
                this.state.type,
                this.state.state,
            )
        }
        setTimeout(() => window.scrollBy({top: 250, behavior: "smooth"}), 100);
    }

    changeType(e: React.ChangeEvent<HTMLSelectElement>) {
        e.preventDefault();
        this.updateState({type: e.target.value})
    }

    changeState(e: React.ChangeEvent<HTMLSelectElement>) {
        e.preventDefault();
        this.updateState({state: e.target.value})
    }

    setExtraCostsName(e: React.ChangeEvent<HTMLInputElement>) {
        this.updateState({extraCostsName: e.target.value})
    }

    editExtraCosts(id: string) {
        const extraCosts = (AppSettingController.getSetting() as MarketSettingLocalStorage).extraCosts;
        if (!extraCosts) return;

        const selectedExtraCosts = extraCosts.find(t => t.id === id);
        setTimeout(() => window.scrollBy({top: -250, behavior: "smooth"}), 100);

        if (selectedExtraCosts)
            this.updateState(({
                ...selectedExtraCosts,
                error: false,
                message: "",
                isActiveEdit: true,
            }))
    }

    setDiscount(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        const numberValue = +value;

        if (value.includes('.') || !Number.isInteger(numberValue)) {
            return this.updateState({
                ...this.state,
                error: true,
                message: i18n.t("setting.error.extraCostsMustBeInteger")
            });
        }

        this.updateState({...this.state, error: false, message: "", extraCostsPercentage: value});

        if (this.state.type === "percentage") {
            if (numberValue > 100) {
                return this.updateState({
                    ...this.state,
                    error: true,
                    message: i18n.t("setting.error.extraCostsMax100")
                });
            }

            if (numberValue <= 0) {
                return this.updateState({
                    ...this.state,
                    error: true,
                    message: i18n.t("setting.error.extraCostsMin0")
                });
            }

            return this.updateState({
                extraCostsPercentage: value,
                error: false,
                message: ""
            });
        } else {
            this.updateState({extraCostsPrice: value});
        }
    }

    private updateState(state: object) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}